import React, { useState, useEffect } from 'react';
import TrainingPartListItem from './TrainingPartListItem.tsx';


function TrainingPartList(props) {
    const [trainingPartsData, setTrainingPartsData] = useState(props.training.trainingParts);

    useEffect(() =>  { if (props.training.id) { setTrainingPartsData(props.training.trainingParts) }}, [props.training.id, props.training.trainingParts]);

    const updateTrainingPartHandler = (trainingPart2Update) => {

        const updatedTrainingParts = trainingPartsData.map(
            (trainingPartItm) => {
                if (trainingPartItm.id === trainingPart2Update.id) {
                    return trainingPart2Update;
                } else {
                    return trainingPartItm;
                }
            }
        );

        let newTrainingValue = {...props.training};
        newTrainingValue.trainingParts = updatedTrainingParts;
        setTrainingPartsData(updatedTrainingParts);
        props.updateTrainingPartList(updatedTrainingParts);
    };

    const removeTrainingPartHandler = (trainingPart2Remove) => {
        // if not saved
        let newTrainingPartList = undefined;
        if (trainingPart2Remove.id < 0) {
            newTrainingPartList = props.training.trainingParts.filter(trainingPart => trainingPart.id !== trainingPart2Remove.id);
        } else {
            let newTrainingPart2Remove = { ...trainingPart2Remove, isDeleted: true};
            newTrainingPartList = props.training.trainingParts.map(
                (trainingPartItm) => {
                    if (trainingPartItm.id === trainingPart2Remove.id) {
                        return newTrainingPart2Remove;
                    } else {
                        return trainingPartItm;
                    }
                }
            );           
         };
        let newTrainingValue = {...props.training};
        newTrainingValue.trainingParts = newTrainingPartList;
        setTrainingPartsData(newTrainingPartList);
        props.updateTrainingPartList(newTrainingPartList);
    };


    const handleAddTrainingPart = (event) => {
        const initalTrainingPart = {
            id: -1, // Temporary ID for unsaved parts
            trainingId: props.training.id !== -1 ? props.training.id : undefined, // Check if training ID is valid
            partTime: 0,
            partType: "BC",
            hrZone: 0,
            mapType: "NONE"      
        }
    
        let newTempId = -1000; // Start with negative IDs for temporary entries
        trainingPartsData.forEach(element => {
            if (element.id <= newTempId) {
                newTempId = element.id - 1; // Decrement temp ID for uniqueness
            }
        });
    
        // Prepare new training part
        let newTrainingPart = { ...initalTrainingPart };
        newTrainingPart.trainingId = props.training.id !== -1 ? props.training.id : undefined; // Ensure valid training ID
        newTrainingPart.id = newTempId; // Assign a unique temp ID
    
        // Add the new training part to the list
        let newTrainingParts = [...trainingPartsData, newTrainingPart]; 
    
        // Update local state and pass the updated parts list to the parent component
        setTrainingPartsData(newTrainingParts);
        props.updateTrainingPartList(newTrainingParts);
    
        event.preventDefault();
    };
    
    const showTrainingPartItems = () => { 
        if (trainingPartsData) return trainingPartsData.map((listItem) => <TrainingPartListItem key={listItem.id} training={props.training} trainingPart={listItem} updateTrainingPartHandler={updateTrainingPartHandler} removeTrainingPartHandler={removeTrainingPartHandler}/> );    
    };

    return (
        <div className="card my-3">
        <div className="card-header d-flex justify-content-between align-items-center">
            Część treningu
            <button type="button"  id="addAddPart" className="btn btn-success" onClick={handleAddTrainingPart}>+</button>
        </div>
        <div className="card-body">
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">Rodzaj</th>
                        <th scope="col">Czas</th>
                        <th scope="col">strefa HR</th>
                        <th scope="col">Typ mapy</th>
                        <th scope="col">Akcja</th>
                    </tr>
                </thead>
                <tbody>
                { showTrainingPartItems() }
                </tbody>
            </table>
            </div>
        </div>
    );

};

export default TrainingPartList;